import { useState, useEffect, useRef } from 'react'
import { IconButton } from '@mui/material'

// Copy icon — swaps to a checkmark for ~1.5s after copying, then reverts.
function CopyIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  )
}

function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

// Small copy-to-clipboard icon button. No tooltip/snackbar — the icon swap
// to a checkmark is the only feedback. Extracted out of App.jsx so
// SuggestionPanel.jsx can use it too without a circular import (App.jsx
// already imports SuggestionPanel.jsx).
// ariaLabel: the button's accessible name ("copy to clipboard" by default).
// buttonRef: lets a caller's own text link trigger the same copy, and so the
// same checkmark feedback, by clicking the button (2026-10-12).
export function CopyButton({ value, ariaLabel = 'copy to clipboard', buttonRef = null }) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef(null)
  useEffect(() => () => clearTimeout(timeoutRef.current), [])
  if (!value) return null
  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation()
        navigator.clipboard.writeText(value)
        setCopied(true)
        clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => setCopied(false), 1500)
      }}
      ref={buttonRef}
      sx={{ p: 0.25, color: 'text.secondary' }}
      aria-label={ariaLabel}
    >
      {copied ? <CheckIcon /> : <CopyIcon />}
    </IconButton>
  )
}
